"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _lockHelpers = require("composer-lib/lib/helpers/lockHelpers");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _immutable = require("immutable");

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _Presence = _interopRequireDefault(require("composer-lib/data/model/Presence"));

var _PresencePopover = _interopRequireDefault(require("composer-lib/components/presence/PresencePopover"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _UIAvatar = _interopRequireDefault(require("ui-addon-avatars/UIAvatar"));

var _UIMedia = _interopRequireDefault(require("UIComponents/layout/UIMedia"));

var _UIMediaBody = _interopRequireDefault(require("UIComponents/layout/UIMediaBody"));

var _UIMediaLeft = _interopRequireDefault(require("UIComponents/layout/UIMediaLeft"));

var _UINotificationBadge = _interopRequireDefault(require("UIComponents/badge/UINotificationBadge"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _Users = _interopRequireDefault(require("composer-lib/data/model/Users"));

var langKey = function langKey(key) {
  return "composer-lib.header.PresenceAvatars." + key;
};

var _default = (0, _createReactClass.default)({
  displayName: "PresenceMoreCommentersAvatar",
  mixins: [_reactAddonsPureRenderMixin.default, _ComponentWithPartials.default],
  propTypes: {
    auth: _propTypes.default.object.isRequired,
    dropdownPlacement: _propTypes.default.string,
    commenters: _propTypes.default.instanceOf(_immutable.Iterable).isRequired,
    dropdownOpen: _propTypes.default.number,
    lock: _propTypes.default.instanceOf(_Lock.default).isRequired,
    getPopoverToggleOpen: _propTypes.default.func.isRequired,
    getPrefix: _propTypes.default.func.isRequired,
    open: _propTypes.default.bool,
    presence: _propTypes.default.instanceOf(_Presence.default).isRequired,
    renderShortUserTitle: _propTypes.default.func.isRequired,
    saveState: _propTypes.default.instanceOf(_SaveState.default).isRequired,
    toggleOpen: _propTypes.default.func.isRequired,
    users: _propTypes.default.instanceOf(_Users.default).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      dropdownPlacement: 'bottom'
    };
  },
  hasCommenterRequestingAccess: function hasCommenterRequestingAccess() {
    var _this$props = this.props,
        auth = _this$props.auth,
        commenters = _this$props.commenters,
        lock = _this$props.lock,
        presence = _this$props.presence,
        saveState = _this$props.saveState;
    var locked = (0, _lockHelpers.compositionLocked)(lock, auth, saveState);
    return !locked && commenters.some(function (v) {
      return presence.requesters.has(v.id);
    });
  },
  renderCommenterLine: function renderCommenterLine(commenter, withDropdown) {
    var _this$props2 = this.props,
        auth = _this$props2.auth,
        getPopoverToggleOpen = _this$props2.getPopoverToggleOpen,
        lock = _this$props2.lock,
        presence = _this$props2.presence,
        renderShortUserTitle = _this$props2.renderShortUserTitle,
        saveState = _this$props2.saveState;
    var email = commenter.email,
        id = commenter.id;
    var locked = (0, _lockHelpers.compositionLocked)(lock, auth, saveState);
    var className = (0, _classnames.default)({
      requester: !locked && presence.requesters.has(id),
      'with-dropdown': withDropdown
    });
    return _react.default.createElement(_UIMedia.default, {
      className: className,
      key: id,
      onClick: this.partial(getPopoverToggleOpen, id)
    }, _react.default.createElement(_UIMediaLeft.default, null, _react.default.createElement(_UIAvatar.default, {
      lookup: {
        type: 'hubSpotUserEmail',
        primaryIdentifier: email
      },
      size: "xs"
    })), _react.default.createElement(_UIMediaBody.default, null, renderShortUserTitle(commenter)));
  },
  renderMoreCommentersPopover: function renderMoreCommentersPopover() {
    var _this = this;

    var _this$props3 = this.props,
        commenters = _this$props3.commenters,
        dropdownOpen = _this$props3.dropdownOpen,
        getPopoverToggleOpen = _this$props3.getPopoverToggleOpen,
        getPrefix = _this$props3.getPrefix;
    return _react.default.createElement("div", null, commenters.map(function (commenter) {
      var id = commenter.id;
      return _react.default.createElement(_PresencePopover.default, Object.assign({}, _this.props, {
        key: id,
        open: dropdownOpen === id,
        prefix: getPrefix(commenter),
        renderChildren: _this.renderCommenterLine,
        toggleOpen: _this.partial(getPopoverToggleOpen, id),
        user: commenter
      }));
    }));
  },
  renderAvatar: function renderAvatar() {
    var _this$props4 = this.props,
        commenters = _this$props4.commenters,
        open = _this$props4.open,
        toggleOpen = _this$props4.toggleOpen;
    var hasRequests = this.hasCommenterRequestingAccess();
    var classNames = (0, _classnames.default)({
      'more-commenters': !hasRequests,
      'dropdown-open': open
    });

    var avatar = _react.default.createElement("span", {
      className: classNames,
      onClick: toggleOpen
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: langKey('count'),
      options: {
        count: commenters.size
      }
    }));

    if (hasRequests) {
      return _react.default.createElement(_UINotificationBadge.default, {
        badgeDescription: "Editing access requested",
        className: "more-commenters",
        placement: "inset",
        size: "small"
      }, avatar);
    }

    return avatar;
  },
  render: function render() {
    var _this$props5 = this.props,
        commenters = _this$props5.commenters,
        dropdownPlacement = _this$props5.dropdownPlacement,
        open = _this$props5.open;

    if (commenters.size <= 0) {
      return null;
    }

    return _react.default.createElement(_UIPopover.default, {
      className: "more-commenters-popover",
      content: this.renderMoreCommentersPopover(),
      open: open,
      placement: dropdownPlacement
    }, this.renderAvatar());
  }
});

exports.default = _default;
module.exports = exports.default;